module.exports = __webpack_public_path__ + "a78ec63f71bd8da8d82cec0c024db345.svg";